<template>
  <b-modal
    id="modal-products-sold-out"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
  >
    <div v-if="productsCart" class="container-modal-sold-out">
      <img
        src="@/assets/icons/delete-gray-icon.svg"
        class="close-modal"
        @click="sendEmailProductSoldout()"
      />
      <div>
        <img
          src="@/assets/icons/icon-alert_triangle.svg"
          class="d-flex mx-auto mb-4"
        />
        <h4 class="title-sold-out">
          {{
            productsCart.find(p => p.status == 1)
              ? 'Algunos productos de tu bolsa ya no están disponibles'
              : 'Los productos de tu bolsa ya no están disponibles'
          }}
        </h4>
        <p class="descripcion-sold-out">
          {{
            productsCart.find(p => p.status == 1)
              ? 'Lo sentimos, algunos artículos de tu bolsa se han agotado y los hemos eliminado. Pero no te preocupes, ¡puedes seguir explorando la tienda para encontrar más opciones!'
              : 'Lo sentimos, todos los articulos de tu bolsa  se han agotado y se han removidos de tu bolsa. Pero no te preocupes, ¡puedes seguir explorando la tienda para encontrar más opciones!'
          }}
        </p>
      </div>
      <div v-if="getProductsSoldOut.length < productsCart.length" class="mb-4">
        <div
          v-for="(product, index) in getProductsSoldOut"
          :key="index"
          class="product-sold-out"
        >
          <div class="container-img">
            <img :src="product.referencia.imagenes[0]" alt="" />
            <span>Agotado</span>
          </div>
          <div class="container-info-product-sold-out col">
            <p>{{ product.producto_titulo }}</p>
            <p>
              <span class="font-weight-bold"
                >${{
                  formatPrice(
                    product.producto_precio
                      ? product.producto_precio
                      : product.precio,
                  )
                }}</span
              >
              <del
                v-if="
                  (product.producto_precio_antes &&
                    product.producto_precio_antes > 0) ||
                    (product.precio_antes && product.precio_antes > 0)
                "
                style="color: #ADB2B7; font-weight: bold; padding-left: .5rem;"
                >${{
                  formatPrice(
                    product.producto_precio_antes
                      ? product.producto_precio_antes
                      : product.precio_antes,
                  )
                }}</del
              >
            </p>
            <p>
              Talla: {{ product.referencia.talla.name }} -
              {{ product.referencia.color_nombre }}
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="!dataCart.cliente_correo"
        class="d-none d-md-flex align-items-center mb-4"
      >
        <label class="d-flex mx-0 ms-md-1">
          <input
            v-model="sendEmail"
            class="tyc-checkbox"
            type="checkbox"
            checkmark="checkmark"
          />
          <span class="checkmark"></span>
        </label>
        <p class="mb-0" style="font-size: 1rem">
          <b>Avísame cuando esté disponible.</b>
        </p>
      </div>
      <div v-if="sendEmail" class="position-relative">
        <input
          id="email"
          v-model="email"
          type="email"
          placeholder="Correo electrónico"
          class="payment-input w-100 mb-5"
          @blur="validateEmail()"
          @change="validateEmail()"
          @focus="validEmail = false"
        />
        <span v-if="validEmail" class="payment-error-label"
          >Este campo es obligatorio</span
        >
        <span v-if="email" class="newlatter-error-input"
          >Correo electrónico</span
        >
      </div>
      <div class="d-flex flex-wrap ">
        <button
          class="col-10 mx-auto btn-primary"
          :style="sendEmail && !validateCorreo ? 'opacity: .6;' : ''"
          :disabled="sendEmail && !validateCorreo"
          @click="sendEmailProductSoldout()"
        >
          Seguir comprando
        </button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      email: '',
      show: true,
      sendEmail: false,
      validEmail: false,
    }
  },
  computed: {
    ...mapState('cart', ['dataCart', 'productsCart']),
    /* eslint-disable */
    validateCorreo() {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(this.email)
    },
    getProductsSoldOut() {
      let products = this.productsCart.filter(p => p.status == 0)
      return products
    },
  },
  methods: {
    ...mapActions('cart', ['registerProductsSoldout']),
    validateEmail() {
      this.validEmail = !this.validateCorreo;
    },
    async sendEmailProductSoldout() {
      var tempEmail = this.sendEmail ? this.email : ''
      await this.registerProductsSoldout({ correo: tempEmail })
    },
    formatPrice(val) {
      return new Intl.NumberFormat('de-DE').format(val)
    },
  },
}
</script>
<style>
#modal-products-sold-out .modal-content {
  border-radius: 12px;
}
#modal-products-sold-out .container-modal-sold-out {
  max-width: 400px;
  margin-right: auto;
  margin-left: auto;
  padding: 1rem;
}
#modal-products-sold-out .container-modal-sold-out .title-sold-out {
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  margin-bottom: 1rem;
  color: #654062;
}
#modal-products-sold-out .container-modal-sold-out .descripcion-sold-out {
  text-align: center;
  border-bottom: 1px solid #EAF0FC;
  padding-bottom: 1rem;
}
.product-sold-out {
  display: flex;
  flex-wrap: wrap;
  padding: 1rem 0;
  border-bottom: 1px solid #EAF0FC;
}
.product-sold-out:first-child {
  padding-top: 0;
}
.product-sold-out .container-img {
  max-width: 80px;
  position: relative;
  margin-bottom: auto;
}
.product-sold-out .container-img span {
  position: absolute;
  bottom: -3px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  border-radius: 5px;
  left: 0;
  padding: .3rem;
  background-color: #FFF4DE;
}
.product-sold-out .container-info-product-sold-out {
  text-align: start;
  padding-left: 1rem;
}
.product-sold-out .container-info-product-sold-out p {
  font-size: 16px;
  margin-bottom: .4rem;
}
.product-sold-out .container-info-product-sold-out p:first-child {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.close-modal {
  position: absolute;
  right: 1rem;
  top: 1rem;
  cursor: pointer;
}
</style>
